export default "__VITE_ASSET__5257982d__"